import { atom } from 'recoil';
import { getConfigVariable } from '../../fn/Config';

// Search result ordering sent to the backend as OrderingMode. The website
// Worker experiment `appt_ordering_daypart` redirects its treatment arm to
// `?rv=b`. The param name is deliberately opaque.
export const ORDERING_MODES = {
  LEGACY: 'legacy',
  DAYPART: 'daypart',
};

const ORDERING_MODE =
  getConfigVariable('ORDERING_MODE') || ORDERING_MODES.LEGACY;

export function resolveOrderingMode(search = window.location.search) {
  const forced = new URLSearchParams(search).get('rv');
  if (forced === 'b') return ORDERING_MODES.DAYPART;
  if (forced !== null) return ORDERING_MODES.LEGACY;
  return ORDERING_MODE === ORDERING_MODES.DAYPART
    ? ORDERING_MODES.DAYPART
    : ORDERING_MODES.LEGACY;
}

const resolved = resolveOrderingMode();
window.orderingMode = resolved;

export const orderingMode = atom({
  key: 'orderingMode',
  default: resolved,
});

/**
 * The resolved ordering mode for search bodies. Read from window so the
 * non-React search code doesn't need the atom threaded through it.
 */
export function getOrderingMode() {
  return window.orderingMode || resolved;
}
